<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">Accounts</a>
  </div>
  <nb-select class="theme-select" [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select>
</div>

<div class="header-container">
  <nb-actions size="small">

    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action> 
    <nb-action class="control-item" icon="email-outline"></nb-action> -->
    <nb-action class="control-item" icon="bell-outline"></nb-action>
    <nb-action class="financial-year-action">
      <div class="financial-year-control">
        <span class="financial-year-badge">FY</span>
        <ngx-search-select
          class="financial-year-select"
          [options]="financialYears"
          displayKey="label"
          valueKey="value"
          placeholder="Search financial year"
          noResultsText="No financial year found"
          [(ngModel)]="selectedFinancialYear"
          (ngModelChange)="changeFinancialYear($event)">
        </ngx-search-select>
      </div>
    </nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user
        class="logged-user"
        [nbContextMenu]="userMenu"
        [onlyPicture]="userPictureOnly"
        [showName]="true"
        [showTitle]="true"
        [name]="user?.name"
        [title]="user?.role"
        [picture]="user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
